<style>
    [v-cloak] {
        display: none;
    }

    .v-application--wrap {
        background-color: #e1e1e1;
    }

    .v-application--wrap {
        background-color: #e1e1e1;
    }
</style>


<template>
    <v-app v-cloak>

        <v-app-bar light app v-cloak v-if="isLoggedIn" :color="customerInfo.styles.navColor">
            <!--v-if="isLoggedIn">-->
            <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
            <v-toolbar-side-icon style="cursor:pointer">
                <router-link to="/">
                    <v-img class="mr-3 v-toolbar-title" height="47px" :src="require(`./assets/CustomerLogos/${CustomerStyle.logoName}.png`)">
                    </v-img>
                </router-link>
            </v-toolbar-side-icon>
            <v-toolbar-title class="header" :color="CustomerStyle.navTextColor">Web Management Portal</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon to="/Home" v-bind="attrs"
                           :color="CustomerStyle.navTextColor"
                           v-on="on">
                        <v-icon>mdi-home</v-icon>
                    </v-btn>
                </template>
                <span>Dashboard Home</span>
            </v-tooltip>

            <v-tooltip bottom v-for="(module, index) in customerModules" :key="index" v-if="customerModules">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon
                           v-bind="attrs"
                           v-on="on"
                           :color="CustomerStyle.navTextColor"
                           :to="{name:module.routerLink, query: {modulekey: module.moduleKey } }">
                        <v-icon>{{module.routerIcon}}</v-icon>
                    </v-btn>
                </template>
                <span>{{module.routerText}}</span>
            </v-tooltip>


            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon to ="/MyProfile"
                           v-bind="attrs"
                           v-on="on"
                           :color="CustomerStyle.navTextColor">
                        <v-icon>mdi-account-cog</v-icon>
                    </v-btn>
                </template>
                <span>My Profile</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon to="/UserManagement"
                           v-bind="attrs"
                           v-on="on"
                           :color="CustomerStyle.navTextColor"
                           >
                        <v-icon>mdi-account-group</v-icon>
                    </v-btn>
                </template>
                <span>Manage Users</span>
            </v-tooltip>


            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs"
                           :color="CustomerStyle.navTextColor"
                           v-on="on" v-on:click="LogOff">
                        <v-icon>mdi-shield-lock</v-icon>
                    </v-btn>
                </template>
                <span>Sign Out</span>
            </v-tooltip>

        </v-app-bar>
        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>




<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
            drawer: false,
            group: null,
            sidebarMenu: true,
            toggleMini: false,
            CustomerStyle: ''
        }),
        mounted() {
            // eslint-disable-line no-debugger
            this.CustomerStyle = this.$store.getters.user.currentCustomer.styles
        },
        computed: {
            isLoggedIn: function () { return this.$store.getters.user.isAuthenticated },
            customerModules: function () { return this.$store.getters.user.customerModules },
            customerInfo: function () { return this.$store.getters.user.currentCustomer },
            customerStyles: function () { return this.$store.getters.user.currentCustomer.cssName }
        },
        methods: {
            LogOff: function () {
                this.$store.commit('RevokeToken');
                this.$router.push('/Login');
            },
        }
    }
</script>



